const DAYS_ORDER = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];

const formatWeekHours = (workingHours) => {
    if (!workingHours) return "No hours";

    const openDays = DAYS_ORDER.filter((day) => workingHours?.[day]?.open);

    if (openDays.length === 0) return "Closed";

    const groups = [];

    DAYS_ORDER.forEach((day) => {
        const data = workingHours?.[day];
        const label = data?.open
            ? data.from && data.to
                ? `${data.from}-${data.to}`
                : "Hours unavailable"
            : "Closed";
        const previousGroup = groups[groups.length - 1];

        if (previousGroup?.label === label) {
            previousGroup.end = day;
        } else {
            groups.push({ start: day, end: day, label });
        }
    });

    return groups
        .map(({ start, end, label }) => {
            const range = start === end
                ? start.slice(0, 3)
                : `${start.slice(0, 3)}-${end.slice(0, 3)}`;

            return `${range} ${label}`;
        })
        .join(", ");
};

export default formatWeekHours;
